import { LoadingOverlay } from "@mantine/core";
import axios from "axios";
import React, { useEffect, useReducer, useState } from "react";
import rawShindanJSON from "../../../data/shindan.json";
import "../styles.scss";
import { GET_LAST_ANSWER_URL } from "./const";
import { AppContext } from "./context";
import CurrentQuestion from "./currentQuestion";
import reducer from "./reducer";
import { Answer, State } from "./type";

const useDidMount = (func: Function) =>
    useEffect(() => {
        func();
    }, []);

const initialState: State = {
    currentQuestionNo: 1,
    displayQuestionNo: 1,
    answers: [],
    finish: false,
    loading: false,
    lastAnswer: null,
    isFirstView: true,
    isBackState: false,
};

const fetchLastAnswerIfLogin = (dispatch: Function, customerId: string) => {
    dispatch({ type: "FETCH_INIT" });

    const args = {
        params: {
            customerId,
        },
        headers: {
            "Content-Type": "application/json",
        },
    };
    axios
        .get(GET_LAST_ANSWER_URL, args)
        .then((res) => {
            //@ts-ignore
            dispatch({ type: "SET_LAST_ANSWER", lastAnswer: res.data.answer });
            dispatch({ type: "FETCH_SUCCESS" });
        })
        .catch((res) => {
            dispatch({ type: "FETCH_FAILURE" });
        });
};

const App: React.VFC<{ isLogin: boolean; customerId: string }> = (props) => {
    useDidMount((): void => {
        //@ts-ignore
        $("#shopify-section-footer").remove();
        //@ts-ignore
        $("#admin-bar-iframe").remove();

        setQuestions(rawShindanJSON);
        props.isLogin &&
            !!props.customerId &&
            fetchLastAnswerIfLogin(dispatch, props.customerId);
    });

    const [state, dispatch] = useReducer(reducer, initialState);
    const [questions, setQuestions] = useState(null);

    const lastAnswers = (): Answer[] => {
        return !!state.lastAnswer
            ? state.lastAnswer.filter(
                  (answer) => answer.questionNo == state.currentQuestionNo
              )
            : [];
    };

    // もう一度診断するのボタンを押して、/apps/known-youself?start_questionに遷移した時
    // Q1からスタートさせるために、
    // isFirstViewがfalseにして、URLから?start_questionを消す
    useEffect(() => {
        try {
            const url = new URL(window.location.href);
            const params = url.searchParams;

            if (params.has("start_question")) {
                console.log("start_question flow");
                dispatch({ type: "CLOSE_FIRST_VIEW" });

                // URLから?start_questionを消す
                params.delete("start_question");
                history.replaceState("", "", url.pathname);
            }
        } catch (error) {
            console.error(error);
        }
    }, []);

    // ブラウザバック時の処理
    // 診断TOPページ(=isFirstViewがtrue)のときも、currentQuestionNoが1なので、
    // FirstViewかどうかに応じて処理を分けている
    useEffect(() => {
        history.pushState(null, null, null);
        window.addEventListener("popstate", overridePopstate, false);
        return () =>
            window.removeEventListener("popstate", overridePopstate, false);
    }, [state.isFirstView, state.currentQuestionNo]);

    // FirstView遷移、質問変更時にスクロール位置をTOPに移動
    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById("rootShindan").scrollTop = 0;
    }, [state.isFirstView, state.currentQuestionNo]);

    const overridePopstate = () => {
        if (state.isFirstView) {
            history.back();
        } else if (!state.isFirstView && state.currentQuestionNo == 1) {
            dispatch({ type: "OPEN_FIRST_VIEW" });
        } else if (state.currentQuestionNo > 1) {
            dispatch({ type: "BACK_PREVIOUS_QUESTION" });
        }
    };

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            <LoadingOverlay
                visible={state.loading}
                className="skrwd-LoadingOverlay"
            />
            {!!questions && !state.loading && (
                <CurrentQuestion
                    questions={questions}
                    currentQuestionNo={state.currentQuestionNo}
                    state={state}
                    dispatch={dispatch}
                    isLogin={props.isLogin}
                    lastAnswers={lastAnswers()}
                />
            )}
        </AppContext.Provider>
    );
};

export default App;
